import { z } from 'zod';
import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
const DirectMessageLogInboundSchema = z
    .object({
    conversationPlayer: z.string().transform(playerIdNameParser),
    lastUnreadMessageId: z.number(),
    messages: z.array(z.object({
        id: z.number(),
        fromPlayerId: z.number().optional(),
        messageHtml: z.string()
    }))
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'privatemsg_log',
    ...rest
}));
export const DIRECT_MESSAGE_LOG_PAYLOAD_DEFINITION = {
    zodSchema: DirectMessageLogInboundSchema
};
